module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "solana.ddbfa4ff.svg";